import { db, serviceTagsCollection } from "@repo/ui";
import { onSnapshot, orderBy, query } from "firebase/firestore";
import { useEffect, useState } from "react";
import type { ServiceTag } from "../types";

export function useServiceTags(
	companyId?: string | null,
	serviceId?: string | null,
): ServiceTag[] {
	const [tags, setTags] = useState<ServiceTag[]>([]);

	useEffect(() => {
		if (!companyId || !serviceId) {
			setTags([]);
			return;
		}

		const tagsRef = serviceTagsCollection(db, companyId, serviceId);
		const tagsQuery = query(tagsRef, orderBy("label", "asc"));

		const unsubscribe = onSnapshot(
			tagsQuery,
			(snapshot) => {
				const nextTags = snapshot.docs
					.map((tagDoc) => ({ ...tagDoc.data(), id: tagDoc.id }))
					.sort((a, b) => {
						const deletedA = a.deletedAt ? 1 : 0;
						const deletedB = b.deletedAt ? 1 : 0;
						if (deletedA !== deletedB) return deletedA - deletedB;
						return a.label.localeCompare(b.label);
					});
				setTags(nextTags);
			},
			(error) => {
				console.error(`Error fetching tags for service ${serviceId}:`, error);
				setTags([]);
			},
		);

		return unsubscribe;
	}, [companyId, serviceId]);

	return tags;
}
